import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "../../core";
import { environment } from "environments/environment";
import {
  HomeAdmImobiliariaResponse,
  HomeUsuarioPlano1Response,
  HomeUsuarioPlano2Response,
  HomeAdmSistemaResponse,
  HomeParceiroResponse
} from "./home.response";

@Injectable({ providedIn: 'root' })
export class HomeService extends BaseService {
  private readonly homeEndpoint = `${environment.urlEdducaImobApi}EdducaImobCore/Home/`;

  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Home para ADM_IMOBILIARIA
   */
  getHomeAdmImobiliaria(): Observable<HomeAdmImobiliariaResponse> {
    return this.http.get<HomeAdmImobiliariaResponse>(
      `${this.homeEndpoint}GetHomeAdmImobiliaria`,
      { headers: this.getHeader(true) }
    );
  }

  /**
   * Home para USUARIO_IMOBILIARIA (detecta plano automaticamente no backend)
   */
  getHomeUsuario(): Observable<HomeUsuarioPlano1Response | HomeUsuarioPlano2Response> {
    return this.http.get<HomeUsuarioPlano1Response | HomeUsuarioPlano2Response>(
      `${this.homeEndpoint}GetHomeUsuario`,
      { headers: this.getHeader(true) }
    );
  }

  /**
   * Home para ADM_SISTEMA
   */
  getHomeAdmSistema(): Observable<HomeAdmSistemaResponse> {
    return this.http.get<HomeAdmSistemaResponse>(
      `${this.homeEndpoint}GetHomeAdmSistema`,
      { headers: this.getHeader(true) }
    );
  }

  /**
   * Home para PARCEIRO
   */
  getHomeParceiro(): Observable<HomeParceiroResponse> {
    return this.http.get<HomeParceiroResponse>(
      `${this.homeEndpoint}GetHomeParceiro`,
      { headers: this.getHeader(true) }
    );
  }
}
